/* ============================================================
   NORTHSHEEP — the disc says what the disc will show

   Owner, 20 Sep 2026: "i also noticed the you may also like pills dont update
   with the main collection like it still shows 3 white instead of 4".

   Both numbers were true. Liquid prints the colour COLLECTION's count, and
   since the discs started linking to the parent collection with a filter on,
   that is no longer the page they open. On the sheepskins the two disagree:
   "White Sheepskins" is built from TITLE CONTAINS "White Sheepskin" and holds
   three, while the colour filter reads the northsheep.filter_colour metafield,
   where the Icelandic white also says White — so the page the disc opens shows
   four. A count that does not survive the click is worse than no count.

   So the row asks the destination. One fetch of
   /collections/<parent>?view=ns-colour-counts returns every filter value with
   its count — the same data the filter menu on that page is drawn from — and
   every disc in the row is corrected from it.

   IT COSTS ONE REQUEST, AND USUALLY NOT EVEN THAT:
     - nothing is fetched until the row is near the viewport, and on a product
       page it sits below the fold,
     - the answer is kept in sessionStorage for fifteen minutes, so the rest
       of the visit is free (same convention as the Sale check), and
     - a disc whose number is already right is not touched, so the common case
       is invisible.

   If the fetch fails, the Liquid number stays. It is a correction, not a
   dependency.
   ============================================================ */
(function () {
  'use strict';

  var TTL = 15 * 60 * 1000;
  var rows = document.querySelectorAll('[data-ns-colour-band][data-ns-counts-from]');
  if (!rows.length || !window.fetch) return;

  function cacheGet(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (!v || Date.now() - v.ts > TTL) return null;
      return v.data;
    } catch (e) {
      return null;
    }
  }
  function cacheSet(key, data) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), data: data }));
    } catch (e) {}
  }

  function apply(row, payload) {
    var param = row.getAttribute('data-ns-counts-param');
    if (!payload || !payload.filters || !param) return;
    var map = null;
    for (var i = 0; i < payload.filters.length; i++) {
      if (payload.filters[i].param === param) {
        map = payload.filters[i].values;
        break;
      }
    }
    if (!map) return;

    row.querySelectorAll('[data-ns-disc-value]').forEach(function (disc) {
      var v = disc.getAttribute('data-ns-disc-value');
      var el = disc.querySelector('[data-ns-disc-count]');
      if (!el || !(v in map)) return;
      var n = map[v];
      /* A colour that the destination has nothing of would send the shopper
         to an empty page. Better to drop the disc than to print a zero. */
      if (n === 0) {
        disc.hidden = true;
        return;
      }
      if (String(n) !== el.textContent.trim()) el.textContent = String(n);
    });
  }

  function load(row) {
    var base = row.getAttribute('data-ns-counts-from');
    if (!base) return;
    var url = base + (base.indexOf('?') > -1 ? '&' : '?') + 'view=ns-colour-counts';
    var key = 'northsheep_colour_counts:' + base;

    var hit = cacheGet(key);
    if (hit) {
      apply(row, hit);
      return;
    }

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (d) {
        if (!d) return;
        cacheSet(key, d);
        apply(row, d);
      })
      .catch(function () {});
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          load(e.target);
        });
      },
      { rootMargin: '600px 0px' }
    );
    rows.forEach(function (row) {
      io.observe(row);
    });
  } else {
    rows.forEach(load);
  }
})();
